
import Vue from 'vue';
import Button from '~/components/builders/Base/Button.vue';

export default Vue.extend({
    name: 'BaseWelcomeStepPage',
    components: {
        Button,
    },
    props: {
        pageNumber: { type: Number, required: true },
        pageCount: { type: Number, required: true },
        isLoading: { type: Boolean, default: false },
        isFormValid: { type: Boolean, default: false },
        clickBack: {
            type: Function,
            default: () => {},
        },
        clickNext: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {};
    },
    methods: {
        emitClickBack() {
            this.$emit('clickBack');
        },
        emitClickNext() {
            this.$emit('clickNext');
        },
    },
});
